import type { FC } from 'react';
import styled from 'styled-components';
import { Box } from '@interstate/components/Box';
import { Button } from '@interstate/components/Button';

const FooterContainer = styled(Box)`
    && {
        display: flex;
        justify-content: flex-end;
        gap: 16px;
        padding: 16px;
    }
`;

interface SlideoutFooterProps {
    onCancel: () => void;
    onCreateScenarios: () => void;
    canCreateScenarios: boolean;
}

export const SlideoutFooter: FC<SlideoutFooterProps> = ({ onCancel, onCreateScenarios, canCreateScenarios }) => (
    <FooterContainer>
        <Button buttonStyle="secondary" onClick={onCancel} data-testid="ai-alt-deal-structure-cancel-button">
            Cancel
        </Button>
        <Button
            buttonStyle="primary"
            data-testid="ai-alt-deal-structure-create-button"
            disabled={!canCreateScenarios}
            onClick={onCreateScenarios}
        >
            Create Scenario(s)
        </Button>
    </FooterContainer>
);
